import request from "@/util/request.js";
// 事件概况
export const selectWarnLogPage = (token, current, size) => {
  return request.post("api/sansint-energy/warnLog/selectWarnLogPage", {
    token,
    current,
    size,
    warnItem: ""
  });
};
// 各类事件统计
export const eventStatistics = tenantId => {
  return request.post("api/sansint-energy/safeBigScreen/eventStatistics", {
    tenantId
  });
};
// 负载总功率
export const selectLineP = tenantId => {
  return request.post("api/sansint-energy/safeBigScreen/selectLineP", {
    tenantId
  });
};
